module.exports = __webpack_public_path__ + "static/media/getting-started-system-requirements.6bd9b5ca.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/getting-started-system-requirements.md
// module id = 1097
// module chunks = 0